<template>
  <div :class="{ 'accordion-item--active': visible }" class="accordion-item">
    <dt class="accordion-item__header" @click="open">
      <slot name="header"></slot>
      <button class="accordion-item__button"></button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-show="visible" class="accordion-item__body">
        <div class="accordion-item__body-inner">
          <slot name="body"></slot>
        </div>
      </dd>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordionItem',
  props: {},
  inject: ['Accordion'],
  data () {
    return {
      index: null
    }
  },
  computed: {
    visible () {
      return this.index === this.Accordion.active
    }
  },
  methods: {
    open () {
      if (this.visible) {
        this.Accordion.active = null
      } else {
        this.Accordion.active = this.index
      }
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  },
  created () {
    this.index = this.Accordion.count++
  }
}
</script>

<style lang="sass" scoped>cl
.accordion-item
  cursor: pointer
  border: 1px solid #E7E7E7
  border-radius: 3px
  position: relative
  & + &
    margin-top: 10px

.accordion-item__header
  display: flex
  justify-content: space-between
  color: rgba(51, 51, 51, 0.8)
  font-size: 16px
  line-height: 1.5
  padding: 20px

.accordion-item__body
  margin: 0

  &-inner
    padding: 0 20px 20px
    font-size: 14px
    line-height: 150%
    color: #909090

.accordion-item__button
  display: block
  position: relative
  width: 30px
  height: 25px
  background: transparent
  border: 0

  &:after
    content: ''
    display: block
    position: absolute
    width: 10px
    height: 10px
    border: solid #909090
    border-width: 0 1px 1px 0
    background: transparent
    top: 50%
    left: 50%
    transform: translate(-50%, -75%) rotate(45deg)
    transition: .2s

.accordion-item--active .accordion-item__button::after
   transform: translate(-50%, -25%) rotate(-135deg)

.accordion-item-enter-active,
.accordion-item-leave-active
  will-change: height
  transition: height 0.3s ease
  overflow: hidden

.accordion-item-enter,
.accordion-item-leave-to
  height: 0 !important

+mmin($tablet)
  .accordion-item__header
    font-size: 20px
    padding: 30px
  .accordion-item__body-inner
    font-size: 16px
    padding: 0 30px 30px
  .accordion-item__button
    height: 30px
</style>
